export default "__VITE_ASSET__gLTHJb_q__"